export class ChronodriveCardInjectorWrapper {

  constructor(){}

  // TODO
  basketProductIds() {
    return [];
  }

  /**
   * action to do when we remove card from DOM
   * @param {DomElement} webcCard a recipe card
   */
  // eslint-disable-next-line no-unused-vars
  onHideCard(webcCard){
    throw new Error('You must implement \'onHideCard\' for this retailer');
  }

  /**
   * @returns the string displayed in recipe-helper after "Retrouvez le détails " (ex: "dans l'onglet Mes Repas")
   */
  recipeRecapLocationString() {
    return undefined;
  }

  cardHeaderText() {
    return 'Recette commandable';
  }

  // Container the holds all the product tiles
  detectCardsContainer() {
    return document.getElementById('productListZone');
  }

  cardsPositionsByScreenWidth() {
    if (window.prevItemPerLine === 2) {
      return [3, 7, 12, 17];
    } if (window.prevItemPerLine === 3) {
      return [2, 7, 14, 21];
    } if (window.prevItemPerLine === 4) {
      return [3, 10, 19, 25];
    } else {
      return [4, 7, 15, 23];
    }
  }

  cardContainerCssClasses() {
    return ['item', 'item--recipe'];
  }

  // Pass DOM elements representing items (articles), and return their respective ids
  // When the id cannot be found, exclude it from the resultset to avoid returning array with null elements
  getProductsIds(contextElements) {
    return contextElements.map(element => {
      const actionsElement = element?.getElementsByClassName('item-actions') && element.getElementsByClassName('item-actions')[0];
      return actionsElement?.getAttribute('data-cug');
    }).filter(id => !!id);
  }
}